"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.buildForeignEntityScriptHelpers = buildForeignEntityScriptHelpers;
/**
 * Sync foreign-entity read helpers for descriptions / conditions / effects.
 * Prefer description and condition scripts; mutations of foreign entities are not provided.
 */
function buildForeignEntityScriptHelpers(foreignEntityLookup, player) {
    const defaultOwner = () => String(player.userId ?? '').trim();
    return {
        /**
         * True if `entityId` exists in the owner's library home for `adventureId`.
         * Omit `ownerUserId` to use the current player's user id.
         */
        foreignEntityExists(adventureId, entityId, ownerUserId) {
            if (!foreignEntityLookup)
                return false;
            const owner = ownerUserId !== undefined && ownerUserId !== null
                ? String(ownerUserId).trim()
                : defaultOwner();
            if (!owner)
                return false;
            return foreignEntityLookup.foreignEntityExists(String(adventureId ?? '').trim(), String(entityId ?? '').trim(), owner);
        },
        /**
         * Display name from the foreign library entity, or "" if missing/unauthorized.
         */
        getForeignEntityDisplayName(adventureId, entityId, ownerUserId) {
            if (!foreignEntityLookup)
                return '';
            const owner = ownerUserId !== undefined && ownerUserId !== null
                ? String(ownerUserId).trim()
                : defaultOwner();
            if (!owner)
                return '';
            return foreignEntityLookup.getForeignEntityDisplayName(String(adventureId ?? '').trim(), String(entityId ?? '').trim(), owner);
        },
        /**
         * Read-only foreign entity variable value, or undefined if missing/unauthorized.
         */
        getForeignEntityVariable(adventureId, entityId, name, ownerUserId) {
            if (!foreignEntityLookup)
                return undefined;
            const owner = ownerUserId !== undefined && ownerUserId !== null
                ? String(ownerUserId).trim()
                : defaultOwner();
            if (!owner)
                return undefined;
            return foreignEntityLookup.getForeignEntityVariable(String(adventureId ?? '').trim(), String(entityId ?? '').trim(), String(name ?? '').trim(), owner);
        }
    };
}
//# sourceMappingURL=foreignEntityScriptHelpers.js.map